module.exports = __webpack_public_path__ + "static/media/icon-bath-private.d6ff55b5.svg";